/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm } from '@insticator/insticator-ui';



/* ++++++++++ --------------- MONETIZATION - UNIT LOAD RPM PAGE : STYLES --------------- ++++++++++ */
export default {
    unitloadrpm: {
    }
};
